import Component from '~/components/component';
import Plyr from 'plyr'

export default class VideoTmp extends Component {
    constructor(...args) {
		super(...args);
        this.getDom();
    }
    bind(){

        if( this.dom.play ) {

            this.dom.play.addEventListener('click', () => {
                // this.Player.play()
                let parent = this.dom.component.parentElement
                if(parent){
                    let imgPoster = parent.querySelector('img')
                    console.log(parent)
                    if( imgPoster )
                        imgPoster.style.display = 'none'
                    this.dom.poster.style.display = 'none'
                    this.Player.play()
                }

            })
        }
    }
	getDom() {
        this.dom.player = this.dom.component.querySelector('.js-player');
        this.dom.play = this.dom.component.querySelector('.js-videoTmp-play')
        this.dom.poster = this.dom.component.querySelector('.js-videoTmp-poster')
	}
	init() {
		this.Player = new Plyr(this.dom.player, {
            debug: true,
            hideControls: true,
			controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
			youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
			vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false, playsinline: true, controls: false }
		});
		this.Player.on('ended', event => {
			this.Player.stop();
		});
    }
    

    pause(){
        this.Player.stop();
        let parent = this.dom.component.parentElement
        if(parent){
            let imgPoster = parent.querySelector('img')
            if( imgPoster )
                imgPoster.style.display = ''
            if( this.dom.poster )
                this.dom.poster.style.display = ''
        }
    }


    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/video-tmp/video-tmp.js